import { MenuItem } from '../models/menu.model';
import { ADMIN_ROLES, MANAGEMENT_ROLES } from '../auth/roles';

export const MENU_ITEMS: MenuItem[] = [
  { label: 'Entidades', icon: 'pi pi-users', path: '/entidades', roles: MANAGEMENT_ROLES },
  {
    label: 'menu.top100Group',
    icon: 'pi pi-chart-bar',
    children: [
      { label: 'menu.top100Detailed', icon: 'pi pi-list', path: '/top100' },
      { label: 'menu.top100Summary', icon: 'pi pi-table', path: '/top100-summary' },
    ],
  },
  { label: 'Usuarios', icon: 'pi pi-users', path: '/usuarios', roles: MANAGEMENT_ROLES },
  { label: 'Bodegas', icon: 'pi pi-warehouse', path: '/bodegas', roles: ADMIN_ROLES }
];
